export const WeeklyInspectionTypes = {
  GET_WEEKLY_INSPECTION_LIST: 'GET_WEEKLY_INSPECTION_LIST',
  CLEAR_WEEKLY_INSPECTION_LIST: 'CLEAR_WEEKLY_INSPECTION_LIST',
};
